<q9-section *ngIf="refModelNode?.owner">
  <div title>{{ 'SIDEBAR.OWNER' | translate }}</div>
  <div content>
    <q9-user-info [user]="refModelNode.owner"></q9-user-info>
  </div>
</q9-section>
